import { render, staticRenderFns } from "./outboundReviewProductRecords.vue?vue&type=template&id=3e47abf3&scoped=true"
import script from "./outboundReviewProductRecords.vue?vue&type=script&lang=js"
export * from "./outboundReviewProductRecords.vue?vue&type=script&lang=js"
import style0 from "./outboundReviewProductRecords.vue?vue&type=style&index=0&id=3e47abf3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e47abf3",
  null
  
)

export default component.exports